import { render, staticRenderFns } from "./FooterImageDesktop.vue?vue&type=template&id=05437f3e"
import script from "./FooterImageDesktop.vue?vue&type=script&lang=js"
export * from "./FooterImageDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
